
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KURSIST_TYPE_STATISTIK"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kursist_type_statistik"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Gender_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Ansoger_via_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Indgang_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Startdato"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Online"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KURSIST_TYPE_E_LEARN_STATISTIK"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kursist_type_e_learn_statistik"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Gender_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Ansoger_via_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Indgang_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Startdato"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Online"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":628}};
    doc.loc.source = {"body":"query KURSIST_TYPE_STATISTIK($type: String, $fromDate: Date, $toDate: Date) {\n    kursist_type_statistik(type: $type, fromDate: $fromDate, toDate: $toDate) {\n        Status_id\n        Status\n        Gender_id\n        Ansoger_via_id\n        Indgang_id\n        kode\n        Startdato\n        Online\n    }\n}\n\n\nquery KURSIST_TYPE_E_LEARN_STATISTIK($type: String, $fromDate: Date, $toDate: Date) {\n    kursist_type_e_learn_statistik(type: $type, fromDate: $fromDate, toDate: $toDate) {\n        Status_id\n        Status\n        Gender_id\n        Ansoger_via_id\n        Indgang_id\n        kode\n        Startdato\n        Online\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["KURSIST_TYPE_STATISTIK"] = oneQuery(doc, "KURSIST_TYPE_STATISTIK");
        
        module.exports["KURSIST_TYPE_E_LEARN_STATISTIK"] = oneQuery(doc, "KURSIST_TYPE_E_LEARN_STATISTIK");
        
